






















































































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, { ALERT_TYPE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import FileData from '@/domain/FileData'
import CsvRequest from '@/domain/CsvRequest'
import CsvResponse from '@/domain/CsvResponse'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
  },
})
export default class MemberCsvTool extends Mixins(GlobalMixin) {
  errors: string[] = []
  importFileSelected = false
  exportFileSelected = false
  importFile: FileData | undefined = undefined
  exportFile: FileData | undefined = undefined

  /**
   * 作業用ファイルに変換ボタンのクリック
   */
  onImport(event: Event) {
    this.alertBarIsVisible = false
    if ((this.$refs.importObserver as Vue & { validate: () => boolean }).validate() && this.importFile !== undefined) {
      const header = CsvResponse.getHeader().join(",")
      const csvErrors = this.validateImportCsv(this.importFile.content)
      if (csvErrors.length !== 0) {
        /* CSVフォーマットエラー */
        this.errors = csvErrors
        this.alert("依頼ファイルの読み込みでエラーが発生しました", ALERT_TYPE.ERROR)
      } else {
        const csvData = this.parseImportCsv(this.importFile.content)
        const csvDataStatus5 = this.convertStatus5(csvData)
            .map(x => x.toCsv(","))
            .reduce((p, x) => p + "\r\n" + x, header)
        const csvDataStatus7 = this.convertStatus7(csvData)
            .map(x => x.toCsv(","))
            .reduce((p, x) => p + "\r\n" + x, header)
        const status5File = this.convertFile(this.importFile.filename.replace(".csv", "_status5.csv"), "text/csv", csvDataStatus5)
        const status7File = this.convertFile(this.importFile.filename.replace(".csv", "_status7.csv"), "text/csv", csvDataStatus7)
        this.download(status5File)
        this.download(status7File)
      }
    } else {
      event.stopPropagation()
    }
  }

  /**
   * インポートファイルの選択
   */
  onChangeImportFile(file: File | undefined) {
    this.importFile = undefined
    this.importFileSelected = false
    if (file !== undefined && file.name.toLowerCase().slice(-4) === ".csv") {
      const reader = new FileReader()
      reader.onload = () => {
        if (typeof reader.result === "string") {
          this.importFile = {filename: file.name, content: reader.result}
          this.importFileSelected = true
        }
      }
      reader.readAsText(file, "SJIS")
    }
  }

  /**
   * 報告ファイルに変換ボタンのクリック
   */
  onExport(event: Event) {
    this.alertBarIsVisible = false
    if ((this.$refs.exportObserver as Vue & { validate: () => boolean }).validate() && this.exportFile !== undefined) {
      this.errors = []
      const fileName = "FromBVI" + this.dateTimeUtils.format("yyMMdd_HHmm.csv")
      const commandFileName = fileName.replace(".csv", ".txt")
      const header = CsvResponse.getHeader().join("|")
      const csvErrors = this.validateExportCsv(this.exportFile.content)
      if (csvErrors.length !== 0) {
        /* CSVフォーマットエラー */
        this.errors = csvErrors
        this.alert("作業用ファイルの変換でエラーが発生しました", ALERT_TYPE.ERROR)
      } else {
        const csvData = this.parseExportCsv(this.exportFile.content)
        /* データバリデーション */
        csvData.forEach((x, index) => {
          const rowErrors = x.validate()
          rowErrors.forEach(e => this.errors.push(`${index + 2} 行目: ${e}`))
        })
        if (this.errors.length === 0) {
          /* 報告ファイルに変換およびダウンロード */
          const response = csvData.map(x => x.toCsv("|"))
                    .reduce((p, x) => p + "\r\n" + x, header)
          const responseFile = this.convertFile(fileName, "text/csv", response)
          this.download(responseFile)
          /* ファイル名変換コマンドファイルダウンロード */
          if (csvData.some(x => x.reportNo !== "")) {
            const renameCommand = csvData.filter(x => x.reportNo !== "")
                      .map(x => `ren ${x.reportNo}.pdf ${x.requestId}_${x.reportNo}.pdf\r\n`)
                      .reduce((p, x) => p + x, "rem コマンドプロンプトで、以下のコマンドを実行し、報告書のファイル名を変更してください。\r\n")
            const renameCommandFile = this.convertFile(commandFileName, "text/plain", renameCommand)
            this.download(renameCommandFile)
          }
        }
      }
    } else {
      event.stopPropagation()
    }
  }

  /**
   * エクスポートファイルの選択
   */
  onChangeExportFile(file: File | undefined) {
    this.exportFile = undefined
    this.exportFileSelected = false
    this.errors = []
    if (file !== undefined && file.name.toLowerCase().slice(-4) === ".csv") {
      const reader = new FileReader()
      reader.onload = () => {
        if (typeof reader.result === "string") {
          this.exportFile = {filename: file.name, content: reader.result}
          this.exportFileSelected = true
        }
      }
      reader.readAsText(file, "SJIS")
    }
  }

  /**
   * CSV依頼データのCSVフォーマットバリデーション
   */
  private validateImportCsv(data: string): string[] {
    const errors: string[] = []
    data.split("\r\n").filter((x, index) => index === 0)
        .forEach(x => {
          if (x !== CsvRequest.getHeader().join("|")) {
            errors.push("ヘッダ行が違っています")
          }
        })
    if (errors.length === 0) {
      data.split("\r\n").map(x => x.length === 0 ? 34 : x.split("|").length)
          .forEach((x, index) => {
            if (x !== 34) {
              errors.push(`${index +1} 行目の項目数が不正です`)
            }
          })
    }
    return errors
  }

  /**
   * CSV依頼データのパース
   */
  private parseImportCsv(data: string): CsvRequest[] {
    return data.split("\r\n")
        .filter((x, index) => index !== 0)
        .filter(x => x.length > 0)
        .map(x => {
            const row = x.split("|")
            return new CsvRequest({
                requestId: row[0],
                status: row[1],
                lastModifiedAt: row[2],
                cancelOn: row[3],
                cancelReason: row[4],
                requestRegistrationOn: row[5],
                recommendedScheduledOn: row[6],
                requestConfirmationOn: row[7],
                arriveOn: row[8],
                specimenNo: row[9],
                productName: row[10],
                category: row[11],
                edibleWeight: row[12],
                optionSingle: row[13],
                optionInspection1: row[14],
                optionInspection2: row[15],
                optionInspection3: row[16],
                optionInspection4: row[17],
                additive1: row[18],
                additive2: row[19],
                additive3: row[20],
                additive4: row[21],
                additive5: row[22],
                additive6: row[23],
                excludedParts: row[24],
                note: row[25],
                inspectionType: row[26],
                laboratoryName: row[27],
                companyName: row[28],
                factoryName: row[29],
                writer: row[30],
                manufacturerTel: row[31],
                vendorCode: row[32],
                customerCode: row[33],
                unitOfEdibleWeight: row[34],
        })
    })
  }

  /**
   * CSV報告(作業)データのCSVフォーマットバリデーション
   */
  private validateExportCsv(data: string): string[] {
    const errors: string[] = []
    data.split("\r\n").filter((x, index) => index === 0)
        .forEach(x => {
          if (x !== CsvResponse.getHeader().join(",")) {
            errors.push("ヘッダ行が違っています")
          }
        })
    if (errors.length === 0) {
      data.split("\r\n").map(x => x.length === 0 ? 101 : x.split(",").length)
          .forEach((x, index) => {
            if (x !== 101) {
              errors.push(`${index + 1} 行目の項目数が不正です`)
            }
          })
    }
    return errors
  }

  /**
   * CSV報告(作業)データのパース
   */
  private parseExportCsv(data: string): CsvResponse[] {
    return data.split("\r\n")
        .filter((x, index) => index !== 0)
        .filter(x => x.length > 0)
        .map(x => {
            const row = x.split(",")
            return new CsvResponse({
                requestId: row[0],
                status: row[1],
                lastModifiedAt: row[2],
                cancelOn: row[3],
                cancelReason: row[4],
                requestConfirmationOn: row[5],
                deliveryOn: row[6],
                reportNo: row[7],
                inspectionCompletionOn: row[8],
                requestRegistrationOn: row[9],
                recommendedScheduledOn: row[10],
                companyFactoryName: row[11],
                productName: row[12],
                category: row[13],
                edibleWeight: row[14],
                internalCapacity1: row[15],
                internalCapacity2: row[16],
                internalCapacity3: row[17],
                internalCapacity4: row[18],
                internalCapacity5: row[19],
                internalCapacity6: row[20],
                internalCapacity7: row[21],
                internalCapacity8: row[22],
                internalCapacity9: row[23],
                internalCapacity10: row[24],
                additive1: row[25],
                additive2: row[26],
                additive3: row[27],
                additive4: row[28],
                additive5: row[29],
                additive6: row[30],
                excludedParts: row[31],
                calorie100g: row[32],
                calorie100gUnit: row[33],
                calorie1meal: row[34],
                calorie1mealUnit: row[35],
                calorieInspectionMethod: row[36],
                protein100g: row[37],
                protein100gUnit: row[38],
                protein1meal: row[39],
                protein1mealUnit: row[40],
                proteinInspectionMethod: row[41],
                lipid100g: row[42],
                lipid100gUnit: row[43],
                lipid1meal: row[44],
                lipid1mealUnit: row[45],
                lipidInspectionMethod: row[46],
                carbohydrate100g: row[47],
                carbohydrate100gUnit: row[48],
                carbohydrate1meal: row[49],
                carbohydrate1mealUnit: row[50],
                carbohydrateInspectionMethod: row[51],
                sodium100g: row[52],
                sodium100gUnit: row[53],
                sodium1meal: row[54],
                sodium1mealUnit: row[55],
                sodiumInspectionMethod: row[56],
                moisture100g: row[57],
                moisture100gUnit: row[58],
                moisture1meal: row[59],
                moisture1mealUnit: row[60],
                moistureInspectionMethod: row[61],
                ash100g: row[62],
                ash100gUnit: row[63],
                ash1meal: row[64],
                ash1mealUnit: row[65],
                ashInspectionMethod: row[66],
                optionInspection1: row[67],
                optionInspection100g1: row[68],
                optionInspection100gUnit1: row[69],
                optionInspection1meal1: row[70],
                optionInspection1mealUnit1: row[71],
                optionInspectionMethod1: row[72],
                optionInspection2: row[73],
                optionInspection100g2: row[74],
                optionInspection100gUnit2: row[75],
                optionInspection1meal2: row[76],
                optionInspection1mealUnit2: row[77],
                optionInspectionMethod2: row[78],
                optionInspection3: row[79],
                optionInspection100g3: row[80],
                optionInspection100gUnit3: row[81],
                optionInspection1meal3: row[82],
                optionInspection1mealUnit3: row[83],
                optionInspectionMethod3: row[84],
                optionInspection4: row[85],
                optionInspection100g4: row[86],
                optionInspection100gUnit4: row[87],
                optionInspection1meal4: row[88],
                optionInspection1mealUnit4: row[89],
                optionInspectionMethod4: row[90],
                note1: row[91],
                note2: row[92],
                note3: row[93],
                note4: row[94],
                note5: row[95],
                note6: row[96],
                note7: row[97],
                note8: row[98],
                note9: row[99],
                note10: row[100],
        })
    })
  }

  /**
   * 依頼データのコンバート（ステータス５用）
   */
  private convertStatus5(src: CsvRequest[]): CsvResponse[] {
    const requestConfirmationOn = this.dateUtils.getToday().replace(/-/g, "")
    const deliveryOn = new Date(this.dateTimeUtils.getNowTime() + 1000 * 60 * 60 * 24 * 8).toISOString().substr(0, 10).replace(/-/g, "")
    return src.map(x => {
      return new CsvResponse({
          requestId: x.requestId,
          status: "5",
          lastModifiedAt: x.lastModifiedAt,
          requestConfirmationOn: requestConfirmationOn,
          deliveryOn: deliveryOn,
      })
    })
  }

  /**
   * 依頼データのコンバート（ステータス７用）
   */
  private convertStatus7(src: CsvRequest[]): CsvResponse[] {
    const requestConfirmationOn = this.dateUtils.getToday().replace(/-/g, "")
    return src.map(x => {
      return new CsvResponse({
          requestId: x.requestId,
          status: "7",
          lastModifiedAt: x.lastModifiedAt,
          requestConfirmationOn: requestConfirmationOn,
          requestRegistrationOn: x.requestRegistrationOn,
          recommendedScheduledOn: x.recommendedScheduledOn,
          companyFactoryName: `${x.companyName}/${x.factoryName}` ,
          productName: x.productName,
          category: x.category,
          edibleWeight: x.edibleWeight,
          additive1: x.additive1,
          additive2: x.additive2,
          additive3: x.additive3,
          additive4: x.additive4,
          additive5: x.additive5,
          additive6: x.additive6,
          excludedParts: x.excludedParts,
          calorie100gUnit: "kcal/100g",
          calorie1mealUnit: "kcal/1食当り",
          protein100gUnit: "g/100g",
          protein1mealUnit: "g/1食当り",
          lipid100gUnit: "g/100g",
          lipid1mealUnit: "g/1食当り",
          carbohydrate100gUnit: "g/100g",
          carbohydrate1mealUnit: "g/1食当り",
          sodium100gUnit: "mg/100g",
          sodium1mealUnit: "mg/1食当り",
          moisture100gUnit: "g/100g",
          moisture1mealUnit: "g/1食当り",
          ash100gUnit: "g/100g",
          ash1mealUnit: "g/1食当り",
      })
    })
  }
}
